import { PhysicsConfig } from '../aircraft/AircraftPhysics';

export type AircraftId = 'stealth' | 'gen4' | 'marine';

export interface AircraftData {
  id: AircraftId;
  name: string;
  nameEn: string;
  maxHp: number;
  missiles: number;
  vulcanAmmo: number;
  physics: PhysicsConfig;
  stats: {
    speed: number;    // 1-5
    mobility: number; // 1-5
    defense: number;  // 1-5
    firepower: number;// 1-5
  };
}

const STEALTH_PHYSICS: PhysicsConfig = {
  maxSpeed: 950,
  minSpeed: 150,
  boostMultiplier: 1.3,
  acceleration: 200,
  deceleration: 150,
  pitchRate: 1.5,
  rollRate: 2.0,
  yawCoupling: 0.4,
  mouseSensitivity: 0.002,
  autoLevelStrength: 0.6,
};

const GEN4_PHYSICS: PhysicsConfig = {
  maxSpeed: 800,
  minSpeed: 130,
  boostMultiplier: 1.25,
  acceleration: 180,
  deceleration: 160,
  pitchRate: 2.0,
  rollRate: 2.5,
  yawCoupling: 0.5,
  mouseSensitivity: 0.002,
  autoLevelStrength: 0.5,
};

const MARINE_PHYSICS: PhysicsConfig = {
  maxSpeed: 870,
  minSpeed: 140,
  boostMultiplier: 1.28,
  acceleration: 190,
  deceleration: 155,
  pitchRate: 1.8,
  rollRate: 2.3,
  yawCoupling: 0.45,
  mouseSensitivity: 0.002,
  autoLevelStrength: 0.55,
};

export const AIRCRAFT_LIST: AircraftData[] = [
  {
    id: 'stealth',
    name: 'SF-0 ファントムブレード',
    nameEn: 'SF-0 PHANTOM BLADE',
    maxHp: 100,
    missiles: 24,
    vulcanAmmo: 500,
    physics: STEALTH_PHYSICS,
    stats: { speed: 5, mobility: 3, defense: 3, firepower: 4 },
  },
  {
    id: 'gen4',
    name: 'EF-4 イーグルファング',
    nameEn: 'EF-4 EAGLE FANG',
    maxHp: 120,
    missiles: 18,
    vulcanAmmo: 800,
    physics: GEN4_PHYSICS,
    stats: { speed: 3, mobility: 5, defense: 4, firepower: 3 },
  },
  {
    id: 'marine',
    name: 'ASF-2 オーシャンヴァイパー',
    nameEn: 'ASF-2 OCEAN VIPER',
    maxHp: 110,
    missiles: 24,
    vulcanAmmo: 600,
    physics: MARINE_PHYSICS,
    stats: { speed: 4, mobility: 4, defense: 3, firepower: 4 },
  },
];
